var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuteSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-dot-color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6 62v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,9.5,65.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,9.5,72.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 86.5,
    r: 3.5,
    transform: "rotate(0,9.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 97v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,9.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,9.5,107.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 121.5,
    r: 3.5,
    transform: "rotate(0,9.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,9.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,9.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,9.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 167v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,9.5,170.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 184.5,
    r: 3.5,
    transform: "rotate(0,9.5,184.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 219.5,
    r: 3.5,
    transform: "rotate(0,9.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 62v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,16.5,65.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 90v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,16.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,16.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,16.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,16.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 167,
    width: 7,
    height: 7,
    transform: "rotate(0,16.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 202v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,16.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 209v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,16.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 230v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,16.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 69v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,23.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,79.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 83,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 90v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,23.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 125v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,23.5,128.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,23.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 167,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,23.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,23.5,191.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 195v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,23.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20 209v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,23.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 216,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,23.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,30.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,30.5,107.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 111,
    width: 7,
    height: 7,
    transform: "rotate(0,30.5,114.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,30.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,30.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 146v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,30.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 27 160v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,30.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,30.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,30.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,30.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,37.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,37.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 90v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,37.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,37.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,37.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,37.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 153v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,37.5,156.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 177.5,
    r: 3.5,
    transform: "rotate(0,37.5,177.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,37.5,191.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 205.5,
    r: 3.5,
    transform: "rotate(0,37.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,37.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,37.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,37.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,44.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 83v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,44.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 97v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,44.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,44.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 125v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,44.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,44.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,44.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 153,
    width: 7,
    height: 7,
    transform: "rotate(0,44.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,44.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,44.5,191.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.5,
    cy: 212.5,
    r: 3.5,
    transform: "rotate(0,44.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,44.5,233.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 65.5,
    r: 3.5,
    transform: "rotate(0,51.5,65.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 79.5,
    r: 3.5,
    transform: "rotate(0,51.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48 90v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,51.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,51.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,51.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,51.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48 146v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,51.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 160,
    width: 7,
    height: 7,
    transform: "rotate(0,51.5,163.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 177.5,
    r: 3.5,
    transform: "rotate(0,51.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 48 188v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,51.5,191.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 205.5,
    r: 3.5,
    transform: "rotate(0,51.5,205.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 219.5,
    r: 3.5,
    transform: "rotate(0,51.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,51.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,58.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,58.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 90,
    width: 7,
    height: 7,
    transform: "rotate(0,58.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,58.5,107.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 111,
    width: 7,
    height: 7,
    transform: "rotate(0,58.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 118,
    width: 7,
    height: 7,
    transform: "rotate(0,58.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 55 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,58.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 160,
    width: 7,
    height: 7,
    transform: "rotate(0,58.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,58.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 13v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,65.5,16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,65.5,51.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 55,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,58.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,79.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 83,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 90,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,65.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,65.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 125v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,65.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,65.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 153,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,65.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,65.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 181v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,65.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,65.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,205.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 209,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 216,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,65.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 237v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,65.5,240.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 279v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,65.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 62 286v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,65.5,289.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69 27v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,72.5,30.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 55,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,58.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,72.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 90,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,100.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.5,
    cy: 114.5,
    r: 3.5,
    transform: "rotate(0,72.5,114.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69 125v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,72.5,128.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69 223v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,72.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 237,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,72.5,254.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69 258v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,72.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 69 272v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,72.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 27,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 34v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,79.5,37.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,79.5,51.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 55,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,58.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,65.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,79.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,79.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,79.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,79.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,79.5,156.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 170.5,
    r: 3.5,
    transform: "rotate(0,79.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,79.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 230v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,79.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 251v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,79.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,79.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 76 272v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,79.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83 6v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,86.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,86.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,86.5,65.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 93.5,
    r: 3.5,
    transform: "rotate(0,86.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83 111v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,86.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 118,
    width: 7,
    height: 7,
    transform: "rotate(0,86.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,86.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,86.5,149.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 163.5,
    r: 3.5,
    transform: "rotate(0,86.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83 188v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,86.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,86.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83 244v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,86.5,247.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 83 258v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,86.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,86.5,268.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 289.5,
    r: 3.5,
    transform: "rotate(0,86.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 6v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,93.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 27v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,93.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 41v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,93.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,93.5,51.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,65.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 79.5,
    r: 3.5,
    transform: "rotate(0,93.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 97v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,93.5,100.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,107.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 111,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 118,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 125v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,93.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,93.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 146v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,93.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,93.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,93.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,93.5,219.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 233.5,
    r: 3.5,
    transform: "rotate(0,93.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,93.5,247.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 251v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,93.5,254.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 265v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,93.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 90 272v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,93.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 13v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,100.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 34v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,100.5,37.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 41,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 55v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,100.5,58.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,65.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,100.5,72.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 86.5,
    r: 3.5,
    transform: "rotate(0,100.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,100.5,107.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 111,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 118,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,121.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 177.5,
    r: 3.5,
    transform: "rotate(0,100.5,177.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 191.5,
    r: 3.5,
    transform: "rotate(0,100.5,191.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 202v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,100.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,100.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 237v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,100.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,100.5,254.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 97 258v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,100.5,261.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 289.5,
    r: 3.5,
    transform: "rotate(0,100.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,107.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,107.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 27v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,107.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 41v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,107.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,107.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 62v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,107.5,65.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 100.5,
    r: 3.5,
    transform: "rotate(0,107.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 111v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,107.5,114.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,107.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,107.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,107.5,156.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 184.5,
    r: 3.5,
    transform: "rotate(0,107.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 104 244v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,107.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,107.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,107.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,114.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,114.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,114.5,72.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.5,
    cy: 107.5,
    r: 3.5,
    transform: "rotate(0,114.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,114.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,114.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 153,
    width: 7,
    height: 7,
    transform: "rotate(0,114.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 160v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,114.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,114.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,114.5,191.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 195v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,114.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,114.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 223v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,114.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 237v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,114.5,240.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 251v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,114.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,114.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 272v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,114.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,114.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 286v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,114.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 13v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,121.5,16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 20v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,121.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 41v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,121.5,44.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 48,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 55v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,121.5,58.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,121.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 90v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,121.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,121.5,100.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 114.5,
    r: 3.5,
    transform: "rotate(0,121.5,114.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,121.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 153v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,121.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 174v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,121.5,177.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 181,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 118 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,121.5,191.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.5,
    cy: 212.5,
    r: 3.5,
    transform: "rotate(0,121.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 237,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 272,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,282.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 286,
    width: 7,
    height: 7,
    transform: "rotate(0,121.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,128.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 27v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,128.5,30.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.5,
    cy: 65.5,
    r: 3.5,
    transform: "rotate(0,128.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 90,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,128.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,128.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 125,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,128.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 146v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,128.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,128.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 167v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,128.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 181v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,128.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,128.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,128.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 216v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,128.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 237,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 272,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,282.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 286,
    width: 7,
    height: 7,
    transform: "rotate(0,128.5,289.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 27v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,135.5,30.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 51.5,
    r: 3.5,
    transform: "rotate(0,135.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,135.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,135.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 90v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,135.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,135.5,121.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 142.5,
    r: 3.5,
    transform: "rotate(0,135.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 160,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 167,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,135.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,205.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 209,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 216,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,135.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 132 286v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,135.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,142.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,142.5,16.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 37.5,
    r: 3.5,
    transform: "rotate(0,142.5,37.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 58.5,
    r: 3.5,
    transform: "rotate(0,142.5,58.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,142.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,142.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,142.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,142.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,142.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,142.5,156.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 160,
    width: 7,
    height: 7,
    transform: "rotate(0,142.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 167v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,142.5,170.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 184.5,
    r: 3.5,
    transform: "rotate(0,142.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 223v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,142.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 251v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,142.5,254.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 139 258v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,142.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,142.5,282.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,149.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,149.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 27v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,149.5,30.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 51.5,
    r: 3.5,
    transform: "rotate(0,149.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 62v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,149.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,149.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,149.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,149.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,149.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 139v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,149.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 160,
    width: 7,
    height: 7,
    transform: "rotate(0,149.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,149.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,149.5,191.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,149.5,198.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.5,
    cy: 219.5,
    r: 3.5,
    transform: "rotate(0,149.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 272v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,149.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,149.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 146 286v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,149.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 13v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,156.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 27,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 34v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,156.5,37.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 58.5,
    r: 3.5,
    transform: "rotate(0,156.5,58.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 69v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,156.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,156.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 90,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,156.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,156.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 125,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,156.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,156.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 167,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 174v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,156.5,177.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,156.5,205.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 226.5,
    r: 3.5,
    transform: "rotate(0,156.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 251v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,156.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 272,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 279,
    width: 7,
    height: 7,
    transform: "rotate(0,156.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 153 286v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,156.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,163.5,9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 41v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,163.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,163.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 76v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,163.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,163.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,163.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 111v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,163.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 125,
    width: 7,
    height: 7,
    transform: "rotate(0,163.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,163.5,156.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,163.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,163.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,163.5,205.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.5,
    cy: 219.5,
    r: 3.5,
    transform: "rotate(0,163.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 230v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,163.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 160 237v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,163.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 6,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 13v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,170.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 41,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 55v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,170.5,58.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 62v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,170.5,65.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 90v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,170.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 97v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,170.5,100.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 111,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 118,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 125,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,128.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,170.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 153v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,170.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 160v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,170.5,163.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 177.5,
    r: 3.5,
    transform: "rotate(0,170.5,177.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,170.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,170.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 223v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,170.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 230v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,170.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 244v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,170.5,247.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 258v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,170.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 167 265v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,170.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 6,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 27,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,30.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 34,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,37.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 41,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,177.5,51.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,177.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,177.5,107.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 111,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,114.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,177.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 167v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,177.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,191.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 219.5,
    r: 3.5,
    transform: "rotate(0,177.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 237v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,177.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,177.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 279v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,177.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 174 286v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,177.5,289.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 6,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 27,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 55v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,184.5,58.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 62,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 83v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,184.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 125v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,184.5,128.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 146v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,184.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 167v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,184.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,184.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,184.5,191.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,184.5,198.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.5,
    cy: 226.5,
    r: 3.5,
    transform: "rotate(0,184.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 244v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,184.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,184.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 272v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,184.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181 286v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,184.5,289.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 6,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 13,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 27v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,191.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,191.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 55v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,191.5,58.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 76v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,191.5,79.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 93.5,
    r: 3.5,
    transform: "rotate(0,191.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,191.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,191.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 125,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,191.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 146v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,191.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,191.5,156.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 184.5,
    r: 3.5,
    transform: "rotate(0,191.5,184.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,191.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 188 230v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,191.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,191.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,198.5,9.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 20,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,23.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 62v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,198.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 83v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,198.5,86.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 139v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,198.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 160v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,198.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 167v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,198.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,198.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,198.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 216v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,198.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 237,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,240.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 244v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,198.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: 272,
    width: 7,
    height: 7,
    transform: "rotate(0,198.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 195 279v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,198.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 20v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,205.5,23.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 27,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 34v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,205.5,37.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.5,
    cy: 51.5,
    r: 3.5,
    transform: "rotate(0,205.5,51.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 90v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,205.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,100.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 118v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,205.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 125v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,205.5,128.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,205.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,205.5,177.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 181,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,184.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 209v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,205.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,205.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 265v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,205.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 202 286v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,205.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 6v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,212.5,9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 13v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,212.5,16.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 34,
    width: 7,
    height: 7,
    transform: "rotate(0,212.5,37.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 41v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,212.5,44.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,212.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,212.5,100.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,212.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,212.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,212.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,212.5,142.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 163.5,
    r: 3.5,
    transform: "rotate(0,212.5,163.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,212.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 244v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,212.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,212.5,254.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 209 258v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,212.5,261.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.5,
    cy: 275.5,
    r: 3.5,
    transform: "rotate(0,212.5,275.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 286,
    width: 7,
    height: 7,
    transform: "rotate(0,212.5,289.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 6,
    width: 7,
    height: 7,
    transform: "rotate(0,219.5,9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 13v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,219.5,16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 34v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,219.5,37.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,219.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 55v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,219.5,58.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 69v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,219.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,219.5,79.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 83,
    width: 7,
    height: 7,
    transform: "rotate(0,219.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 90v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,219.5,93.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 104v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,219.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 146v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,219.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,219.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 181v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,219.5,184.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 198.5,
    r: 3.5,
    transform: "rotate(0,219.5,198.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 212.5,
    r: 3.5,
    transform: "rotate(0,219.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 223v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,219.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,219.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 237v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,219.5,240.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 216 265v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,219.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 286,
    width: 7,
    height: 7,
    transform: "rotate(0,219.5,289.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 6,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223 27v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,226.5,30.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223 62v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,226.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,72.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 76,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223 83v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,226.5,86.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.5,
    cy: 128.5,
    r: 3.5,
    transform: "rotate(0,226.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223 139v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,226.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223 167v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,226.5,170.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 226.5,
    cy: 191.5,
    r: 3.5,
    transform: "rotate(0,226.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,233.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 223 244v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,226.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 286,
    width: 7,
    height: 7,
    transform: "rotate(0,226.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 6v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,233.5,9.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 27v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,233.5,30.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 34,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,37.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 41,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,44.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 48v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,233.5,51.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 90v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,233.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,233.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,233.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 132v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,233.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,142.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 167,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,170.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233.5,
    cy: 184.5,
    r: 3.5,
    transform: "rotate(0,233.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 195v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,233.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 209v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,233.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 223v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,233.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 237,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,233.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 230 286v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,233.5,289.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 62v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,240.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 76v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,240.5,79.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 90,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,100.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 118v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,240.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,240.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 146v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,240.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 167v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,240.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 188v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,240.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,205.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 209,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,240.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 265v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,240.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 237 279v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,240.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 62v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,247.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 69,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 83v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,247.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 90v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,247.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,107.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 128.5,
    r: 3.5,
    transform: "rotate(0,247.5,128.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 142.5,
    r: 3.5,
    transform: "rotate(0,247.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,247.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,247.5,177.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,205.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 209,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 223v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,247.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,233.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 247.5,
    r: 3.5,
    transform: "rotate(0,247.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,247.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 272v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,247.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 244 279v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,247.5,282.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 69v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,254.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 76v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,254.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 97v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,254.5,100.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,107.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.5,
    cy: 121.5,
    r: 3.5,
    transform: "rotate(0,254.5,121.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,254.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 146v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,254.5,149.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 153,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,156.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 160v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,254.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 174v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,254.5,177.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251 188v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,254.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 209,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 216,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 223,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,254.5,261.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 76v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,261.5,79.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 111v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,261.5,114.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 139,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,142.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 146v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,261.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 167v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,261.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 181v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,261.5,184.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 209v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,261.5,212.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 223v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,261.5,226.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 230,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,233.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 237,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,268.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 272,
    width: 7,
    height: 7,
    transform: "rotate(0,261.5,275.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 258 279v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,261.5,282.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 72.5,
    r: 3.5,
    transform: "rotate(0,268.5,72.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 93.5,
    r: 3.5,
    transform: "rotate(0,268.5,93.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 104,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,107.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 268.5,
    cy: 121.5,
    r: 3.5,
    transform: "rotate(0,268.5,121.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 153v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,268.5,156.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 160,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 167v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,268.5,170.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 195,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 202v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,268.5,205.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 265 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,268.5,219.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,268.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 76v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,275.5,79.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 83v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,275.5,86.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 97v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,275.5,100.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 104v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,275.5,107.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 132,
    width: 7,
    height: 7,
    transform: "rotate(0,275.5,135.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 146v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(180,275.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 181v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,275.5,184.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 188,
    width: 7,
    height: 7,
    transform: "rotate(0,275.5,191.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 195v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,275.5,198.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 216v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,275.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 272 237v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,275.5,240.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,275.5,247.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 251,
    width: 7,
    height: 7,
    transform: "rotate(0,275.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 258,
    width: 7,
    height: 7,
    transform: "rotate(0,275.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,275.5,268.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 65.5,
    r: 3.5,
    transform: "rotate(0,282.5,65.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 97,
    width: 7,
    height: 7,
    transform: "rotate(0,282.5,100.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 114.5,
    r: 3.5,
    transform: "rotate(0,282.5,114.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 132v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,282.5,135.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 146,
    width: 7,
    height: 7,
    transform: "rotate(0,282.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(-90,282.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 167v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,282.5,170.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 188v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,282.5,191.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 244,
    width: 7,
    height: 7,
    transform: "rotate(0,282.5,247.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 251v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,282.5,254.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,282.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 279 272v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(180,282.5,275.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 289.5,
    r: 3.5,
    transform: "rotate(0,282.5,289.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.5,
    cy: 72.5,
    r: 3.5,
    transform: "rotate(0,289.5,72.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 97v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,289.5,100.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.5,
    cy: 128.5,
    r: 3.5,
    transform: "rotate(0,289.5,128.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 146v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,289.5,149.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 160v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(0,289.5,163.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 167v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,289.5,170.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 289.5,
    cy: 184.5,
    r: 3.5,
    transform: "rotate(0,289.5,184.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 195v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,289.5,198.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 202,
    width: 7,
    height: 7,
    transform: "rotate(0,289.5,205.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 209,
    width: 7,
    height: 7,
    transform: "rotate(0,289.5,212.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 216,
    width: 7,
    height: 7,
    transform: "rotate(0,289.5,219.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 223v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(90,289.5,226.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 244v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(0,289.5,247.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 258v 7h 3.5a 3.5 3.5, 0, 0, 0, 0 -7",
    transform: "rotate(-90,289.5,261.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 265,
    width: 7,
    height: 7,
    transform: "rotate(0,289.5,268.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 286 272v 7h 7a 7 7, 0, 0, 0, -7 -7",
    transform: "rotate(90,289.5,275.5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dot-color",
    gradientUnits: "userSpaceOnUse",
    x1: 6,
    y1: 150,
    x2: 293,
    y2: 150
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fb4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5056fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 6 23.5v 14a 17.5 17.5, 0, 0, 0, 17.5 17.5h 14a 17.5 17.5, 0, 0, 0, 17.5 -17.5v -14a 17.5 17.5, 0, 0, 0, -17.5 -17.5h -14a 17.5 17.5, 0, 0, 0, -17.5 17.5M 23.5 13h 14a 10.5 10.5, 0, 0, 1, 10.5 10.5v 14a 10.5 10.5, 0, 0, 1, -10.5 10.5h -14a 10.5 10.5, 0, 0, 1, -10.5 -10.5v -14a 10.5 10.5, 0, 0, 1, 10.5 -10.5",
    transform: "rotate(0,30.5,30.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,25.95v9.450000000000001C41,38.2,38.2,41,35.05,41H25.95C22.45,41,20,38.55,20,35.05V25.95C20,22.8,22.8,20,25.95,20h9.450000000000001C38.55,20,41,22.45,41,25.95z",
    transform: "rotate(0,30.5,30.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 244 23.5v 14a 17.5 17.5, 0, 0, 0, 17.5 17.5h 14a 17.5 17.5, 0, 0, 0, 17.5 -17.5v -14a 17.5 17.5, 0, 0, 0, -17.5 -17.5h -14a 17.5 17.5, 0, 0, 0, -17.5 17.5M 261.5 13h 14a 10.5 10.5, 0, 0, 1, 10.5 10.5v 14a 10.5 10.5, 0, 0, 1, -10.5 10.5h -14a 10.5 10.5, 0, 0, 1, -10.5 -10.5v -14a 10.5 10.5, 0, 0, 1, 10.5 -10.5",
    transform: "rotate(90,268.5,30.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-1-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279,25.95v9.450000000000001C279,38.2,276.2,41,273.05,41H263.95C260.45,41,258,38.55,258,35.05V25.95C258,22.8,260.8,20,263.95,20h9.450000000000001C276.55,20,279,22.45,279,25.95z",
    transform: "rotate(90,268.5,30.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-square-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M 6 261.5v 14a 17.5 17.5, 0, 0, 0, 17.5 17.5h 14a 17.5 17.5, 0, 0, 0, 17.5 -17.5v -14a 17.5 17.5, 0, 0, 0, -17.5 -17.5h -14a 17.5 17.5, 0, 0, 0, -17.5 17.5M 23.5 251h 14a 10.5 10.5, 0, 0, 1, 10.5 10.5v 14a 10.5 10.5, 0, 0, 1, -10.5 10.5h -14a 10.5 10.5, 0, 0, 1, -10.5 -10.5v -14a 10.5 10.5, 0, 0, 1, 10.5 -10.5",
    transform: "rotate(-90,30.5,268.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-corners-dot-color-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,263.95v9.450000000000001C41,276.2,38.2,279,35.05,279H25.95C22.45,279,20,276.55,20,273.05V263.95C20,260.8,22.8,258,25.95,258h9.450000000000001C38.55,258,41,260.45,41,263.95z",
    transform: "rotate(-90,30.5,268.5)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    height: 300,
    width: 300,
    clipPath: "url('#clip-path-background-color')",
    fill: "#ffffff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    height: 287,
    width: 287,
    clipPath: "url('#clip-path-dot-color')",
    fill: "url('#dot-color')"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    height: 49,
    width: 49,
    clipPath: "url('#clip-path-corners-square-color-0-0')",
    fill: "#fb4646"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    height: 21,
    width: 21,
    clipPath: "url('#clip-path-corners-dot-color-0-0')",
    fill: "#fb4646"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 6,
    height: 49,
    width: 49,
    clipPath: "url('#clip-path-corners-square-color-1-0')",
    fill: "#fb4646"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 20,
    height: 21,
    width: 21,
    clipPath: "url('#clip-path-corners-dot-color-1-0')",
    fill: "#fb4646"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 244,
    height: 49,
    width: 49,
    clipPath: "url('#clip-path-corners-square-color-0-1')",
    fill: "#fb4646"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 258,
    height: 21,
    width: 21,
    clipPath: "url('#clip-path-corners-dot-color-0-1')",
    fill: "#fb4646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuteSms);
export default __webpack_public_path__ + "static/media/cute_sms.8170e75fbe47044e65878307370b4308.svg";
export { ForwardRef as ReactComponent };